import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ValidationService } from '../../../shared/providers/validation.service';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { ExternalMarketing, ExternalMarketingSource } from '../../../shared/models/external-marketing';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { ToastService } from '../../../shared/providers/toast.service';

@Component({
    selector: 'app-external-maketing-add',
    templateUrl: './external-maketing-add.component.html' 
})
export class ExternalMaketingAddComponent implements OnInit {

    @Input() marketingType: any;
    @Input() propertyId: number;
    @Input() marketing: any;
    @Output() close = new EventEmitter();
    @Output() save = new EventEmitter();

    currentData = {} as ExternalMarketing;
    sourcelist = [] as ExternalMarketingSource[];
    IsEditMode = false as boolean;
    isValidDate = true as boolean;
    isValidToDate = false as boolean;
    isSubmit = false as boolean;
    user: any;
    hideSource = false as boolean;    
    fromDate = new Date() as Date;

    constructor(public _validationService: ValidationService,
        private _authenticationService: AuthenticationService,
        private _dashboardService: DashboardService,
        private _toastService: ToastService) {
    }

    ngOnInit() {        
        this.user = this._authenticationService.user
        this.resetModel()
        this._dashboardService.getExternalMarketingSource().subscribe(item => {           
                this.sourcelist = item;
        });

        if (this.marketing) {
            
            this.IsEditMode = true;
            this.currentData = this.marketing;
            this.fromDate = new Date(this.marketing.FromDate);
            this.currentData.FromDate = this.fromDate.toLocaleString();
            this.validateDate();
        }

        this.currentData.Type = this.marketingType.id;
        this.currentData.PropertyId = this.propertyId;
        this.currentData.ModifiedBy = this.user.Id;
        this.currentData.ModifiedDate = new Date();

        if (this.marketingType.id == 4052 || this.marketingType.id == 4053) {
            this.hideSource = true;
        }

    }

    changeDate() {
        
        let date = new Date(this.fromDate);
        if (date.getDay() > 0) {
            this._toastService.addToast({
                title: 'Warning',
                msg: 'Week start date should always be Sunday',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'warning'
            });        
        }

        let first = date.getDate() - date.getDay();
        this.fromDate = new Date(date.setDate(first));        
        this.validateDate();
        
    }

    onClose(event) {
        this.close.emit();
    }

    saveDetails() {        
        this.isSubmit = true;
        if (this.isValidDate && this.currentData.Value != null && this.currentData.Value > 0) {
            this.currentData.FromDate = new Date(this.fromDate.setHours(0, 0, 0, 0)).toLocaleString();
            this.currentData.ToDate = this.currentData.ToDate;
            this.currentData.ModifiedDate = this._validationService.utcify(this.currentData.ModifiedDate)
            this._dashboardService.saveExternalMarketing(this.currentData).subscribe(item => {
                this.save.emit(item);
            })
        }        
    }

    validateDate() {
        var isDate = this._validationService.IsDate(this.fromDate);
        if (isDate == false && this.fromDate != null) {
            this.isValidDate = false;
        }
        else {
            this.isValidDate = true;
        }
    }

    validateToDate() {
        var isDate = this._validationService.IsDate(this.currentData.ToDate);
        if (isDate == false && this.currentData.ToDate != null) {
            this.isValidToDate = false;
        }
        else {
            this.isValidToDate = true;
        }
    }

    resetModel() {
        this.currentData = {
            PropertyId: null,
            FromDate: new Date(new Date().setHours(0, 0, 0, 0)).toLocaleString(),
            Id: 0,
            SourceId: null,
            ToDate: null,
            Type: null,
            Value: null,
            ModifiedBy: null,
            ModifiedDate: null,
            LstDocuments:[]
        }

        let date = new Date(new Date());
        let first = date.getDate() - date.getDay();
        this.fromDate = new Date(date.setDate(first));
    }

}
